import { CookieStorage, ICognitoStorage, ICookieStorageData } from 'amazon-cognito-identity-js';

const tabStorage = (): Storage | undefined =>
  typeof window === 'undefined' ? undefined : window.sessionStorage;

const cookieNames = (): string[] =>
  typeof document === 'undefined'
    ? []
    : document.cookie
        .split(';')
        .map(cookie => decodeURIComponent(cookie.split('=')[0].trim()))
        .filter(Boolean);

export default class SharedSessionStorage implements ICognitoStorage {
  private readonly cookies: CookieStorage;

  private readonly keyPrefix: string;

  private readonly lastAuthUserKey: string;

  constructor(clientId: string, cookieOptions: ICookieStorageData) {
    this.cookies = new CookieStorage(cookieOptions);
    this.keyPrefix = `CognitoIdentityServiceProvider.${clientId}.`;
    this.lastAuthUserKey = `${this.keyPrefix}LastAuthUser`;
  }

  private activeStore(): ICognitoStorage | undefined {
    if (this.cookies.getItem(this.lastAuthUserKey)) {
      this.clearTabSession();
      return this.cookies;
    }
    return tabStorage();
  }

  private clearTabSession(): void {
    const storage = tabStorage();
    Object.keys(storage ?? {})
      .filter(key => key.startsWith(this.keyPrefix))
      .forEach(key => storage?.removeItem(key));
  }

  clearSharedSession(): void {
    cookieNames()
      .filter(name => name.startsWith(this.keyPrefix))
      .forEach(name => this.cookies.removeItem(name));
  }

  getItem(key: string): string | null {
    return this.activeStore()?.getItem(key) ?? null;
  }

  setItem(key: string, value: string): void {
    this.activeStore()?.setItem(key, value);
  }

  removeItem(key: string): void {
    this.cookies.removeItem(key);
    tabStorage()?.removeItem(key);
  }

  clear(): void {
    this.clearSharedSession();
    this.clearTabSession();
  }
}
